import { useRouter } from 'src/hooks'
import { paths } from 'src/routes/paths'
import { useUserStore } from 'src/stores'
import { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

type GuestGuardProps = {
  children: React.ReactNode
}

export default function GuestGuard({ children }: GuestGuardProps) {
  const router = useRouter()
  const user = useUserStore((state) => state.user)
  
  const [searchParams] = useSearchParams()

  const authenticated = !!user

  const check = useCallback(() => {
    if (authenticated) {
      const params = Object.fromEntries(searchParams.entries())

      if (params?.returnTo) {
        router.push(params.returnTo)
      } else {
        router.replace(paths.dashboard.root)
      }
    }
  }, [authenticated, router, searchParams])

  useEffect(() => {
    check()
  }, [check])

  return <>{children}</>
}
